// @ts-ignore
import { BotProductCardVelioSeriesMessage } from '@/types';
import { motion } from 'framer-motion';
import { memo, useMemo } from 'react';
// @ts-ignore
import 'swiper/css';
// @ts-ignore
import 'swiper/css/navigation';
import { Navigation } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import MessageProductCardVelio from './MessageProductCardVelio';
import { SliderArrows, useSliderArrows } from './shared/SliderArrows';

type MessageProductCardSeriesProps = {
  message: BotProductCardVelioSeriesMessage;
  messageId: string;
};

const MessageProductCardSeries = ({ message, messageId }: MessageProductCardSeriesProps) => {
  // Memoize product messages to prevent recreation on each render
  const productMessages = useMemo(() => {
    return message.content.map(product => ({
      role: 'assistant' as const,
      type: 'productCardVelio' as const,
      content: product,
    }));
  }, [message.content]);

  const {
    prevButtonRef,
    nextButtonRef,
    isBeginning,
    isEnd,
    navigation,
    onSwiper,
    onSlideChange,
    onBeforeInit,
  } = useSliderArrows();

  return (
    <motion.div
      className="group relative mx-[-20px] flex max-w-[calc(100%+40px)] flex-col overflow-visible"
      layoutId={`${messageId}-product-card-series`}
      key={`${messageId}`}
    >
      <Swiper
        className="w-full !overflow-visible !px-[20px] [&>.swiper-wrapper]:!overflow-visible"
        slidesPerView={'auto'}
        spaceBetween={8}
        modules={[Navigation]}
        navigation={navigation}
        onSwiper={onSwiper}
        onSlideChange={onSlideChange}
        onBeforeInit={onBeforeInit}
      >
        {productMessages.map((productMessage, index) => (
          <SwiperSlide className="max-w-[80%]" key={message.content[index].id}>
            <MessageProductCardVelio
              message={productMessage}
              messageId={`${messageId}-${message.content[index].id}`}
            />
          </SwiperSlide>
        ))}
      </Swiper>
      <SliderArrows
        prevButtonRef={prevButtonRef}
        nextButtonRef={nextButtonRef}
        isBeginning={isBeginning}
        isEnd={isEnd}
      />
    </motion.div>
  );
};

export default memo(MessageProductCardSeries);
